module.exports = __webpack_public_path__ + "img/logo-bramfeld-large@2x.905992b4.png";